// extracted by mini-css-extract-plugin
export default {"message":"ChatMessage_message__EJ+ym","user":"ChatMessage_user__vbpSv","agent":"ChatMessage_agent__erNJf"};